<template lang="pug">
div.field.is-fullwidth
  h3 {{question.text}}
  
  section(v-if='question.response_type == "Boolean"')
    h4(v-if='question.response.response == "true"') Answer: YES
    h4(v-if='question.response.response == "false"') Answer: NO
    div(v-if='question.yes && question.response.response == "true"').has-background-info.has-text-white-bis.response-message
      p {{question.yes}}
    div(v-if='question.no && question.response.response == "false"').has-background-info.has-text-white-bis.response-message
      p {{question.no}}
  section(v-else)
    h4 Answer: {{question.response.response}}
  section.timestamp
    .is-size-7 Response submitted {{timestamp}}
  hr

</template>

<script>
import moment from "moment";
export default {
  name: "ClosedQuestion",
  props: {
    question: null
  },
  computed: {
    timestamp() {
      return moment(this.question.response.timestamp).format(
        "MMM DD, YYYY [at] hh:mma"
      );
    }
  }
};
</script>

<style scoped lang="less">
h3,
h4,
.timestamp {
  text-align: left;
  padding-left: 0.5rem;
}

.response-message {
  margin: 0.5rem;
  padding: 1rem;
}
</style>